import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/animated-tabs'
import { Button } from "@/components/ui/button";
import * as Icons from 'lucide-react'
import Users from './(tabs)/users';
import CreateUser from '@/components/features/users/create-user';
import Invitations from './(tabs)/invitations';
import { hasRight } from '@/config/rights.config';
import { useAuth } from '@/hooks/use-auth';

const UserManagementPage = () => {
  const { user } = useAuth()
  
  return (
    <div className="p-4 space-y-4 h-full flex flex-col justify-between overflow-auto">
      <header>
        <h1 className="text-3xl font-bold">Gebruikersbeheer</h1>
      </header>

      <Tabs className="h-full overflow-auto" defaultValue="users">
        <div className="flex flex-col justify-between h-full">
          <div className="flex items-center justify-between gap-4">
            <TabsList>
              <TabsTrigger value="users">Gebruikers</TabsTrigger>
              <TabsTrigger value="invitations">Uitnodigingen</TabsTrigger>
            </TabsList>

            {hasRight(user?.role?.name, "USER_MANAGEMENT.WRITE") &&
            <CreateUser
              trigger={
                <Button variant="bright">
                  <Icons.Plus className="w-4 h-4" />
                  Nieuwe gebruiker
                </Button>
              }
            />  
            }
          </div>

          <TabsContent value="users" className="overflow-auto h-full">
            <Users />
          </TabsContent>

          <TabsContent value="invitations" className="overflow-auto h-full">
            <Invitations />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default UserManagementPage;
